import React, { useState, useEffect } from 'react';
import NoticeBoard from '../components/NoticeBoard';
import SearchBar from '../components/SearchBar';
import NoticeDetail from '../components/NoticeDetail';
import './Notice.css';

function Notice() {
  const [notices, setNotices] = useState([]);
  const [filteredNotices, setFilteredNotices] = useState([]);
  const [selectedNotice, setSelectedNotice] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNotices();
  }, []);

  const loadNotices = async () => {
    try {
      const noticeFiles = ['2025-001.md'];
      const loadedNotices = [];

      for (const file of noticeFiles) {
        const response = await fetch(`/notices/${file}`);
        if (response.ok) {
          const text = await response.text();
          const notice = parseMarkdown(text);
          loadedNotices.push(notice);
        }
      }

      setNotices(loadedNotices.sort((a, b) => new Date(b.date) - new Date(a.date)));
      setFilteredNotices(loadedNotices.sort((a, b) => new Date(b.date) - new Date(a.date)));
      setLoading(false);
    } catch (error) {
      console.error('Error loading notices:', error);
      setLoading(false);
    }
  };

  const parseMarkdown = (markdown) => {
    const lines = markdown.split('\n');
    const metadata = {};
    let content = [];
    let inMetadata = false;

    for (let i = 0; i < lines.length; i++) {
      if (lines[i] === '---') {
        inMetadata = !inMetadata;
        continue;
      }
      
      if (inMetadata) {
        const [key, ...valueParts] = lines[i].split(':');
        if (key && valueParts.length > 0) {
          metadata[key.trim()] = valueParts.join(':').trim();
        }
      } else {
        content.push(lines[i]);
      }
    }

    return {
      ...metadata,
      content: content.join('\n')
    };
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    if (!term) {
      setFilteredNotices(notices);
    } else {
      const filtered = notices.filter(notice => 
        notice.title.toLowerCase().includes(term.toLowerCase()) ||
        notice.content.toLowerCase().includes(term.toLowerCase()) ||
        notice.category.toLowerCase().includes(term.toLowerCase())
      );
      setFilteredNotices(filtered);
    }
  };

  const handlePrint = () => {
    if (selectedNotice) {
      window.print();
    }
  };

  return (
    <div className="notice-page">
      <div className="container">
        <h1 className="page-title">전자공고</h1>
        <SearchBar onSearch={handleSearch} />
        
        {loading ? (
          <div className="loading">공고를 불러오는 중...</div>
        ) : (
          <div className="content-wrapper">
            <div className="notice-list-section">
              <NoticeBoard 
                notices={filteredNotices}
                onSelectNotice={setSelectedNotice}
                selectedNotice={selectedNotice}
              />
            </div>
            
            {selectedNotice && (
              <div className="notice-detail-section">
                <NoticeDetail 
                  notice={selectedNotice}
                  onPrint={handlePrint}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Notice;